import lineStyle from './yAxis.splitLine.lineStyle'

export default {
  name: "splitLine",
  nickname: "分隔线",
  desc:
    '坐标轴在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#grid">grid</a> 区域中的分隔线。',
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示分隔线。默认数值轴显示，类目轴不显示。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    interval: {
      name: "interval",
      nickname: "间隔",
      desc:
        '坐标轴分隔线的显示间隔，在类目轴中有效。默认同 <a target="__blank" href="https://echarts.apache.org/zh/option.html#yAxis.axisLabel.interval">axisLabel.interval</a> 一样。',
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    lineStyle,
  },
}
